export interface ToneEvent {
  channel:0|1|2; at:number; duration:number; frequency:number; endFrequency?:number;
  volume:number; priority:number; category:'music'|'sfx'; envelope?:'decay'|'pulse'|'hold'; noise?:boolean;
}
export const midiFrequency = (note:number):number => 440*2**((note-69)/12);
export class AY38910 {
  private node:AudioWorkletNode;
  private constructor(context:AudioContext,destination:AudioNode){
    this.node=new AudioWorkletNode(context,'frog-psg',{numberOfInputs:0,numberOfOutputs:1,outputChannelCount:[1]});
    this.node.connect(destination);
  }
  static async create(context:AudioContext,destination:AudioNode):Promise<AY38910>{
    await context.audioWorklet.addModule('/audio/psg.worklet.js');return new AY38910(context,destination);
  }
  schedule(events:ToneEvent[]):void {this.node.port.postMessage({type:'notes',events});}
  gain(music:number,sfx:number):void {this.node.port.postMessage({type:'gain',music,sfx});}
  clear():void {this.node.port.postMessage({type:'clear'});}
}
